export interface IIpWhitelistDto {
    value: string;
    enabled: boolean;
}

export interface ICreateOrganizationKeyDto {
    name: string;
    apiKey: string;
    ipWhitelist?: IIpWhitelistDto[];
    permissions: string[];
}

export type IUpdateOrganizationKeyDto = Partial<ICreateOrganizationKeyDto>;
